import styled from 'styled-components';

export const Container = styled.header`
	z-index: 99;
	
	background: #043c54;
	box-shadow: rgb(0 0 0 / 16%) 0px 5px 10px;
	width: auto;
	height: 70px;
	position: fixed;
	left: 0;
	top: 0;
	right: 0;

	display: flex;
	align-items: center;
	justify-content: center;

	@media(max-width: 800px) {
		justify-content: flex-end;
	}
`

export const Logo = styled.img`
	width: 80px;
	position: absolute;
	left: 40px;

	@media(max-width: 800px) {
		left: 50%;
		transform: translate(-50%);
	}
`; 

export const NavHeander = styled.nav`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	gap: 0.8rem;

	#link-menu {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: row;
		gap: 1.5rem;
	}

	#btn-mobile__portal {
		display: none;
		border: 0;
		color: #FFF;
		outline-style: none;

	}

	#link-menu:focus {
		outline-style: none;

	}

	@media(max-width: 800px) {
		#link-container {
			margin-bottom: 10px;
			margin-left: 20px;
		}

		#link-menu svg {
			font-size: 24px;
		}

		#link-menu a {
			font-size: 24px;
		}

		#link-menu {
			display: block; 
			position: absolute;
			width: 100%;
			height: 0;
			top: 70px;
			left: 0;
			background: #043c54;
			z-index: 1000;
			visibility: hidden;
			overflow: hidden;
			
			transition: .5s;
		}
		
		#btn-mobile__portal {
			display: block;
		}
		
		&.active #link-menu {
			padding-top: 45px;
			border-top: 2px solid rgb(63, 182, 250);
			height: calc(100vh - 70px);
			visibility: visible;
			overflow-y: auto;

		}

		.active #link-menu {
			display: flex;
		}

		#btn-mobile__portal {
			display: flex;
			padding: 0.5rem 1rem;
			font-size: 1rem;
			border: none;
			background: none;
			cursor: pointer;
			gap: 0.5rem;
		}

		#hamburger {
			border-top: 2px solid;
			width: 20px;
		}

		#hamburger::after,
		#hamburger::before {
			content: '';
			display: block;
			width: 20px;
			height: 2px;
			background: currentColor;
			margin-top: 5px;
			transition: 0.3s;
			position: relative;
		}

		&.active #hamburger {
			border-top-color: transparent;
		}

		&.active #hamburger::before {
			transform: rotate(135deg);
		}

		&.active #hamburger::after {
			transform: rotate(-135deg);
			top: -7px;
		}
	}

`

export const LinkHeander = styled.div`
	display: flex;
	align-items: center;
	
	svg {
		font-size: 20px;
		color: #FFF;
		transition:  0.5s;
		margin-right: 3px;	
		margin-bottom: 4px;
	}

	a {
		font-size: 0.8rem;
		color: #FFF;
		transition: 0.5s;
	}

	&:hover {	
		a, svg {
			color: #3fb6fa;
		}
  	}

	@media (max-width: 1150px) {
		svg {
			font-size: 15px;
		
		}

		a {
			font-size: 12px;
			
		}
	}
	
`